import { nextTick, onMounted, type Ref } from "vue";
import { ApolloQueryResult } from "@apollo/client/core";
import type { ListFixturesQuery } from "@/generated/graphql";
import type { FixturesFormRef, FixturesItem } from "../types";

/**
 * 資材発注登録画面の初期化処理に必要な依存をまとめた型。
 */
interface UseFixturesRegisterInitParams {
  wordList: Ref<Record<string, string>>;
  fixturesItems: Ref<(FixturesItem | null | undefined)[] | null | undefined>;
  unitItems: Ref<string[]>;
  formRef: Ref<FixturesFormRef>;
  fetchWordList: () => Promise<Record<string, string>>;
  fetchFixtures: () => Promise<ApolloQueryResult<ListFixturesQuery>>;
}

/**
 * 資材発注登録画面の初期化処理を扱う composable。
 */
export const useFixturesRegisterInit = ({
  wordList,
  fixturesItems,
  unitItems,
  formRef,
  fetchWordList,
  fetchFixtures,
}: UseFixturesRegisterInitParams) => {
  onMounted(async (): Promise<void> => {
    const fetchedWordList = await fetchWordList();
    wordList.value = fetchedWordList;

    try {
      const listFixtures = await fetchFixtures();
      if (listFixtures.data?.listFixtures) {
        fixturesItems.value = listFixtures.data.listFixtures;
        fixturesItems.value?.forEach((value) => {
          if (value) {
            value.fixtures_quantity = "-";
          }
        });
      }
    } catch (err: unknown) {
      console.error(err);
      if (err instanceof Error) {
        err.message = "資材情報の取得に失敗しました。";
        throw err;
      } else {
        throw new Error("資材情報の取得に失敗しました。");
      }
    }

    unitItems.value = ["-"];
    for (let i = 1; i < 10; i++) {
      unitItems.value.push(String(i));
    }

    // レンダリング完了後にフォームへ初期値を反映
    await nextTick();
    if (formRef.value && fixturesItems.value) {
      fixturesItems.value.forEach((value) => {
        if (value) {
          formRef.value?.setFieldValue(
            value.fixtures_name,
            value.fixtures_quantity ?? "-",
            true
          );
        }
      });
    }
  });
};
